module.exports = __webpack_public_path__ + "7b1e29918b908e20de3cb29877bf00f4.MP3";